import { useFormContext, useWatch } from 'react-hook-form';

import { Fields } from '@/modules/secrets/constants';
import type { PasswordSecretFormValues } from '@/modules/secrets/schemas';

import { SecretPasskeyRecord } from '../../SecretPasskeyRecord';

export const RemovePasskeyField = () => {
    const { setValue, control } = useFormContext<PasswordSecretFormValues>();
    const passkey = useWatch({ control, name: Fields.PASSKEY });

    if (!passkey?.createdAt) {
        return null;
    }

    return (
        <SecretPasskeyRecord
            createdAt={passkey.createdAt}
            onRemove={() => {
                setValue(Fields.PASSKEY, null, { shouldDirty: true });
            }}
        />
    );
};
